const validate = (values = {}) => {
	const errors = {};

	if (!values.group) errors.group = "Selecione um grupo de permissão";

	return errors;
};

export default validate;
